import { Col, Form, Row, Select, Radio, Tag, Button, Modal, DatePicker, Switch, notification, Spin, Divider, Popconfirm, Alert } from "antd"
import moment from "moment";
import { useEffect, useState } from "react";
import { CloseCircleFilled, PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { DietDetails } from './DietDetails'
import EnergyIcon from '../../../../../../../assets/icons/DietFormIcon/Energy.svg'
import CarbohydrateIcon from '../../../../../../../assets/icons/DietFormIcon/Carbohydrate.svg'
import TotalFatIcon from '../../../../../../../assets/icons/DietFormIcon/TotalFat.svg'
import DietaryFiberIcon from '../../../../../../../assets/icons/DietFormIcon/DietaryFiber.svg'
import ProteinIcon from '../../../../../../../assets/icons/DietFormIcon/Protein.svg'
import { ViewRecipe } from "./ViewRecipe";
import { API_DATE_FORMAT, API_ERR_MESSAGE } from "../../../../../../../config/constant";
import { addAssignDietApi, editAssignDietApi, listOfAssignDietApi, listOfMacrosMicrosApi, listOfMealTimeApi, listOfRecipesApi, updateAssignDietApi } from "../../../../../../../config/Api";
import { FilterApiData } from "../../../../../../../services/FilterApiData";
import { apiErrorMessage } from "../../../../../../../services/ApiError";
import { dietStatusChanged, sendDiet } from "./dietStatus";
import { useParams } from "react-router-dom";

// value of the "None / Not assigned" choice in a meal time's first recipe dropdown
const NONE_RECIPE = 'none'

export const AssignDietForm = () => {
    // nutrient totals add up long decimals (29.924999999999997): show at most 2 places
    const roundTotal = (value) => Math.round((parseFloat(value) || 0) * 100) / 100
    // the nutrients shown under each recipe, by id so renaming them in the master data doesn't hide them
    // (Energy, Carbohydrate, Total Fat, Crude Fiber, Protein)
    const KEY_NUTRIENT_IDS = [27, 21, 5, 3, 6]
    const isKeyNutrient = (nutrient) => KEY_NUTRIENT_IDS.includes(Number(nutrient?.macros_micros_id))
    // each picked recipe's nutrients are kept under "recipe_macros_micros<meal time id>_<position>"
    const recipeTotalsKey = (mealTimeId, position) => "recipe_macros_micros" + mealTimeId + "_" + position

    const [form] = Form.useForm();
    const { Option } = Select;
    const { id } = useParams()

    const [showErr, setShowErr] = useState(false)
    // meal times deliberately left without a recipe ("None / Not assigned" in their first dropdown)
    const [noneMealTimes, setNoneMealTimes] = useState([])
    const isNoneMealTime = (mealTimeId) => noneMealTimes.includes(mealTimeId)
    const [macrosMicrosTotal, setMacrosMicrosTotal] = useState({})
    const [macrosMicrosTotalhtml, setMacrosMicrosTotalhtml] = useState({})
    const [apiData, setApiData] = useState({
        patient_id: id,
        date: [],
        assign_diet: []
    })
    const [dateList, setdateList] = useState([])
    const [allRecipesListOption, setAllRecipedListOption] = useState([])
    const [mealTimeOptions, setMealTimeOptions] = useState([])
    const [mealTimeOptionsList, setMealTimeOptionsList] = useState([])
    const [selectedDate, setSelectedDate] = useState()
    const [noOfDietDays, setNoOfDietDays] = useState([])
    const [macrosMicrosOption, setMacrosMicrosOption] = useState([])
    const [mainActiveMacrosMicros, setMainActiveMacrosMicros] = useState("Macros")

    const [MacrosMicros, setMacrosMicros] = useState({})

    const [isModalVisible, setIsModalVisible] = useState(false)
    const [isDietDaysModalVisible, setIsDietDaysModalVisible] = useState(false)
    const [viewRecipeData, setViewRecipeData] = useState({})
    const [noOfDietDaysErrMsg, setnoOfDietDaysErrMsg] = useState('')
    const [loading, setLoading] = useState(false)
    const [assignDietApiData, setAssignDietApiData] = useState()
    const [datesOfalreadyAssignedDiet, setDatesOfalreadyAssignedDiet] = useState([])
    const [alreadyAssignedDietData, setAlreadyAssignedDietData] = useState([])
    const [flag, setFlag] = useState(false)
    const [MacrosMicrosFlag, setMacrosMicrosFlag] = useState(false)
    const [grandTotal, setGrandTotal] = useState({})
    const [mealTimeTotal, setMealTimeTotal] = useState({})

    // handle the total of macros micros
    //===============================
    const HandleTotalMacrosMicros = (mealtimeId, i) => {
        // console.log("HandleTotalMacrosMicros called");
        // console.log("apiData", apiData);
        if (apiData) {

            let assign_diet_object = handleAssignDietObject(mealtimeId)

            if (assign_diet_object) {
                let allDietRecord = assign_diet_object['assign_diet_recipe'].length > 0 ?
                    assign_diet_object['assign_diet_recipe'][i] : ''

                if (allDietRecord) {
                    if (mealtimeId == assign_diet_object['meal_time_id']) {
                        // console.log("if called");

                        // allDietRecord?.assign_diet_recipe?.map((selectedRecipe, recipeIndex) => {
                        // console.log("sr", allDietRecord);
                        const recipeData = allRecipesListOption.find(allrecipeRecords => allrecipeRecords.id == allDietRecord)

                        // console.log("recipeData", recipeData);
                        if (recipeData?.recipe_macros_micros && recipeData.recipe_macros_micros.length > 0) {
                            let htmlData = [];
                            htmlData.push(`<p class="total-macros-head">Macros</p>`)

                            recipeData?.recipe_macros_micros
                                .map((totalMacorsOfRecipe) => {
                                    if (isKeyNutrient(totalMacorsOfRecipe)) {
                                        htmlData.push(`<p class="mx-1">
                                     ${totalMacorsOfRecipe?.name + ' - ' + roundTotal(totalMacorsOfRecipe?.total) + " " + totalMacorsOfRecipe?.unit}
                                     <p>`)
                                    }
                                })

                            macrosMicrosTotal[recipeTotalsKey(mealtimeId, i)] = recipeData?.recipe_macros_micros
                            macrosMicrosTotalhtml[recipeTotalsKey(mealtimeId, i)] = htmlData
                        }
                        setMacrosMicrosTotalhtml(macrosMicrosTotalhtml);
                        setMacrosMicrosTotal(macrosMicrosTotal);
                    }
                }
            }
        }
    }

    // get the list of all dates on which diet is already assigned to the patient
    // ===================================================
    const getListOfAssignedDietDates = async () => {
        setLoading(true)
        await listOfAssignDietApi({ "patient_id": parseInt(id) })
            .then((res) => {
                if (res.status === 200) {
                    setDatesOfalreadyAssignedDiet(res.data.data);
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            })
            .finally(() => setLoading(false));
    }

    // get the list of all dates and its recipes data on which diet is already assigned to the patient
    // ===================================================
    const getListOfAlreadyAssignedDietData = async (date) => {
        setLoading(true)
        setMacrosMicrosTotal({})
        setMacrosMicrosTotalhtml({})
        // console.log(selectedDate);
        // console.log("called");
        await editAssignDietApi({ "patient_id": parseInt(id), "date": date })
            .then(async (res) => {
                if (res.status === 200) {
                    setAlreadyAssignedDietData(res.data.data);
                    let data = res.data.data
                    setApiData(data);
                    setNoneMealTimes((data?.assign_diet || [])
                        .filter((dietRecord) => (dietRecord.assign_diet_recipe || []).length === 0)
                        .map((dietRecord) => dietRecord.meal_time_id))

                    // for (let j = 0; j < mealTimeOptions.length; j++) {


                    //     // increse the drop down when user click in add new recipe
                    //     //============================
                    //     if (mealTimeOptions[j].id == mealTimeId) {
                    //         mealTimeOptions[j].diet_dropdown_count = 
                    //         data.assign_diet.find((element) => element.meal_time_id == mealTimeRecord.id)?.assign_diet_recipe.length >= parseInt(mealTimeOptions[j].diet_dropdown_count) ?
                    //         data.assign_diet.find((element) => element.meal_time_id == mealTimeRecord.id)?.assign_diet_recipe.length : parseInt(mealTimeOptions[j].diet_dropdown_count)
                    //         setMacrosMicrosFlag(!MacrosMicrosFlag)
                    //     }
                    // }

                    // if assigned diet data already exist then fill recipes dropdown by user selected values 
                    // ===================================================
                    mealTimeOptions.map((mealTimeRecord, mealTimeIndex) => {
                        // get the count the no of dropdown
                        // console.log("TotalRecipeArrayLength", data.assign_diet.find((element) => element.meal_time_id == mealTimeRecord.id)?.assign_diet_recipe.length);


                        // here we set drop down count 
                        // first get the length of assign diet recipe length and also total default drop down count set whih is bigger value of them   
                        //============================================
                        let TotalRecipeArrayLength = data.assign_diet.find((element) => element.meal_time_id == mealTimeRecord.id)?.assign_diet_recipe.length
                        let b = TotalRecipeArrayLength >= parseInt(mealTimeRecord.diet_dropdown_count) ? TotalRecipeArrayLength : parseInt(mealTimeRecord.diet_dropdown_count)

                        setMacrosMicrosFlag(!MacrosMicrosFlag)
                        for (let i = 0; i < b; i++) {
                            // clear all the dropdown  
                            // =====================
                            form.setFieldsValue({
                                ["recipe_dropdown" + mealTimeRecord.id + i]:
                                    ''
                            })
                        }

                        // loop on selected exist diet data to fill dropdowns
                        // ===================================================
                        // a meal time saved without recipes was set to None
                        if (data?.assign_diet?.find((dietRecord) => dietRecord.meal_time_id == mealTimeRecord.id)?.assign_diet_recipe?.length === 0) {
                            form.setFieldsValue({ ["recipe_dropdown" + mealTimeRecord.id + 0]: NONE_RECIPE })
                        }

                        for (let i = 0; i < b; i++) {
                            data?.assign_diet.length > 0 &&
                                data?.assign_diet.map((dietRecord) => {
                                    if (mealTimeRecord.id == dietRecord.meal_time_id) {
                                        b = dietRecord.assign_diet_recipe.length
                                        dietRecord.assign_diet_recipe.map((recipeId, recordIndex) => {

                                            form.setFieldsValue({
                                                ["recipe_dropdown" + mealTimeRecord.id + recordIndex]:
                                                    recipeId
                                            })

                                        })
                                    }
                                })
                        }
                    }
                    )
                    setLoading(false)
                }
            }
            )
            .catch((err) => {
                setLoading(false)

                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    }

    // get the list of all Recipes
    // ===================================================
    const getListOfRecipes = async () => {
        setLoading(true)
        await listOfRecipesApi()
            .then(async (res) => {
                if (res.status === 200) {
                    // setDataSource(res.data.data);
                    // setDisplayData(res.data.data);
                    setAllRecipedListOption(res.data.data);
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    }

    // get the list of all mealtime and its dropdown count to render no of recipe dropdown
    // ===================================================
    const getListOfMealTime = async () => {
        await listOfMealTimeApi()
            .then(async (res) => {
                if (res.status === 200) {
                    // handle the sequence of meal time like 1) breakfast 2) Lunch
                    let temp = FilterApiData(res.data.data);
                    temp.sort(function (a, b) {
                        return a.id - b.id;
                    });
                    setMealTimeOptions([...temp])
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    }
    const getListOfMealTimeOptionsList = async () => {
        await listOfMealTimeApi()
            .then(async (res) => {
                if (res.status === 200) {
                    // handle the sequence of meal time like 1) breakfast 2) Lunch
                    let temp = FilterApiData(res.data.data);
                    setMealTimeOptionsList([...temp])
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    }

    // get the list of all Recipe Macros Micros
    // ===================================================
    const getListOfMacrosMicros = () => {
        listOfMacrosMicrosApi()
            .then((res) => {
                if (res.status === 200) {
                    setMacrosMicrosOption(res.data.data);
                    console.log("datw", res.data.data);
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    }

    // call below function on page load
    //=======================================
    const pageLoadFunctionCall = async () => {

        getListOfMealTime()
        getListOfMealTimeOptionsList()
        getListOfRecipes()
        getListOfMacrosMicros()

        // fill seven days from current date
        //=======================================
        let dateData = []
        for (let index = 0; index < 7; index++) {
            let fullDate = moment().add(index, 'days').format('DD-MM-YYYY')

            // get seven days date from current date 
            let date = moment().add(index, 'days').format('DD');

            // get seven days day name from current date 
            let day = moment().add(index, 'days').format('dddd');
            dateData.push({ "fullDate": fullDate, "date": date, "day": day })
            setdateList(dateData)
        }
        // select default todays date
        setSelectedDate(dateData[0].fullDate)
        form.setFieldValue('date', dateData[0].fullDate)

        getListOfAssignedDietDates()
    }

    useEffect(() => {
        // when mealtime option is set call api
        // pass todays date in api and check if todays diet already assigned if yes then fill that data
        getListOfAlreadyAssignedDietData(moment().format("DD-MM-YYYY"))
        RadioButtonfilter();

        // create the default static state data for assign diet each section (Breakfast,Lunch etc)
        // for (let j = 0; j < mealTimeOptions.length; j++) {
        //     apiData.assign_diet.push({ "meal_time_id": mealTimeOptions[j].id, 'assign_diet_recipe': [] })
        // }
        // setApiData(apiData)
    }, [mealTimeOptions])


    useEffect(() => {
        pageLoadFunctionCall()
    }, [])

    useEffect(() => {
        RadioButtonfilter();
        setMacrosMicros(MacrosMicros);
    }, [MacrosMicrosFlag])

    const RadioButtonfilter = () => {
        for (let j = 0; j < mealTimeOptions.length; j++) {
            if (MacrosMicros[mealTimeOptions[j]?.name + j]) {
                MacrosMicros[mealTimeOptions[j]?.name + j] = MacrosMicros[mealTimeOptions[j]?.name + j]
            } else {
                MacrosMicros[mealTimeOptions[j]?.name + j] = "Macros"
            }
        }
    }

    const aa = (mealTimeId) => {
        // console.log("aa mealTimeId", mealTimeId);
        // console.log("effect called");
        // console.log("mealTimeOptions", mealTimeOptions);

        for (let j = 0; j < mealTimeOptions.length; j++) {
            // apiData.assign_diet.push({"meal_time_id":mealTimeOptions[j].id ,'assign_diet_recipe': []})

            // console.log("mealTimeOptions[j]", mealTimeOptions[j]);
            // console.log("mealTimeOptions[j].diet_dropdown_count", mealTimeOptions[j].diet_dropdown_count);

            // increse the drop down when user click in add new recipe
            //============================
            let meal_time_dropdown_count = handleAssignDietObject(mealTimeOptions[j].id)?.assign_diet_recipe.length >= mealTimeOptions[j].diet_dropdown_count ? handleAssignDietObject(mealTimeOptions[j].id).assign_diet_recipe.length : mealTimeOptions[j].diet_dropdown_count;
            if (mealTimeOptions[j].id == mealTimeId) {
                mealTimeOptions[j].diet_dropdown_count = parseInt(meal_time_dropdown_count) + 1
                setMacrosMicrosFlag(!MacrosMicrosFlag)
                // console.log("mealTimeOptions[j].diet_dropdown_count", mealTimeOptions[j].diet_dropdown_count, mealTimeOptionsList[j].diet_dropdown_count);
            }
            for (let i = 0; i < parseInt(meal_time_dropdown_count); i++) {
                HandleTotalMacrosMicros(mealTimeOptions[j].id, i)
            }
        }
        setMealTimeOptions(mealTimeOptions)
    }

    // here we get the meal time id and return that mealtime id object from assign diet array of api data
    //========================================
    const handleAssignDietObject = (mealtimeId) => {
        return apiData.assign_diet.find(element => element.meal_time_id == mealtimeId)
    }

    // call when selected recipe has changed to calculate the total of macros and micros  
    // =======================================
    useEffect(() => {
        aa()
        macrosMicrosTotalCalculation()
    }, [apiData, flag])

    // code to display the macros values below recipe dropdown
    //================================= 
    const DisplayMacrosValues = ({ totalMacorsOfRecipe }) => {
        if (isKeyNutrient(totalMacorsOfRecipe)) {
            return (
                <p className="mx-1">{totalMacorsOfRecipe?.name} - {roundTotal(totalMacorsOfRecipe?.total)} {totalMacorsOfRecipe?.unit}</p>
            )
        }
    }
    const onFinish = (values) => {
        if (noOfDietDays == []) {
            return setnoOfDietDaysErrMsg("Select Days")
        } else {
            apiData.date = noOfDietDays
        }
    };

    // code to find the total of all macros micros for all mealtimes and the grand total of all mealtimes
    //==================================================
    const macrosMicrosTotalCalculation = () => {
        let gTotal = {}
        let total = {}
        setGrandTotal({})
        setMealTimeTotal({})
        // console.log("macrosMicrosTotal", macrosMicrosTotal);
        Object.entries(macrosMicrosTotal).map(([element, value]) => {
            // "recipe_macros_micros<meal time id>_<position>" -> "recipe_macros_micros<meal time id>"
            // (reading single characters broke for meal time ids or positions of 10 and more)
            let time = element.slice(0, element.lastIndexOf('_'))
            total[time] = total[time] == undefined ? {} : total[time]
            // total[time][recp] = total[time][recp] == undefined ? { } : total[time][recp]

            value.forEach(e => {
                total[time][e.macros_micros_id] = total[time][e.macros_micros_id] == undefined ? {} : total[time][e.macros_micros_id]
                let fTotal = parseFloat(e.total)
                let macData = {
                    name: e.name,
                    type: e.type,
                    total: total[time][e.macros_micros_id].total == undefined ? fTotal : fTotal + total[time][e.macros_micros_id].total,
                    unit: e.unit,
                }
                total[time][e.macros_micros_id] = macData

                gTotal[e.macros_micros_id] = gTotal[e.macros_micros_id] == undefined ? {} : gTotal[e.macros_micros_id]
                let newTotal = {
                    name: e.name,
                    type: e.type,
                    total: gTotal[e.macros_micros_id].total == undefined ? fTotal : fTotal + gTotal[e.macros_micros_id].total,
                    unit: e.unit,
                }
                gTotal[e.macros_micros_id] = gTotal[e.macros_micros_id] == undefined ? newTotal : newTotal
            });

        })
        setMealTimeTotal(total)
        setGrandTotal(gTotal)
    }
    const resetData = () => {
        form.resetFields()
    };

    // call when form is submitted
    // =======================================
    // save the diet; with andSend also email it to the patient (with the PDF) straight away
    const handleSubmit = (task, andSend = false) => {
        // setShowErr()
        // let isBool = false
        // every meal time needs a recipe, or None chosen on purpose
        let isBool = mealTimeOptions.map(element => isNoneMealTime(element.id) || handleSelectedAssignDietRecipeLength(element.id) > 0)
        // ? setShowErr(false) : setShowErr(true)


        isBool && isBool.length > 0 && !isBool.includes(false) ? setShowErr(false) : setShowErr(true)
        // console.log("showErr", isBool);
        setMacrosMicrosFlag(MacrosMicrosFlag)

        // a meal time without a recipe (or None): close the days popup and bring the first warning into view
        if (!(isBool && isBool.length > 0 && !isBool.includes(false))) {
            setIsDietDaysModalVisible(false)
            setTimeout(() => {
                document.querySelector('.meal-time-error')?.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }, 100)
            return
        }

        // no day picked: that error is in the popup, so it stays open
        if (task == "add" && !(assignDietApiData?.date?.length)) {
            setnoOfDietDaysErrMsg('Please select at least one day.')
            return
        }
        setnoOfDietDaysErrMsg('')

        if (isBool && isBool.length > 0 && !isBool.includes(false)) {
            if (task == "add") {

                // console.log("assignDietApiData", assignDietApiData);
                addAssignDietApi(assignDietApiData)
                    .then((res) => {
                        if (res.status == 200) {
                            notification.success({
                                message: andSend ? "Diet saved. Sending it to the patient..." : "Diet saved. It is not sent to the patient yet.",
                            });
                            if (andSend) sendDiet(id, assignDietApiData.date)
                            dietStatusChanged()
                            setIsDietDaysModalVisible(false)
                            // the sent dates now have a diet: show Update Diet and hide them from Select Days
                            getListOfAssignedDietDates()
                            // getListOfMealTime()
                        }
                    })
                    .catch((err) => {
                        notification.error({
                            message: apiErrorMessage(err),
                        });
                    });
            }
            if (task == "update") {
                // console.log("apiData", apiData, assignDietApiData);
                apiData.date = [selectedDate]
                apiData.patient_id = id
                // console.log(apiData);

                updateAssignDietApi(apiData)
                    .then((res) => {
                        if (res.status == 200) {
                            notification.success({
                                message: andSend ? "Diet updated. Sending it to the patient..." : "Diet updated. The change is not sent to the patient yet.",
                            });
                            if (andSend) sendDiet(id, [selectedDate])
                            dietStatusChanged()
                        }
                    })
                    .catch((err) => {
                        notification.error({
                            message: apiErrorMessage(err),
                        });
                    });
            }
        }


    }
    const handleOk = () => {
        setIsModalVisible(false);
    };
    const handleCancel = () => {
        setIsModalVisible(false);
    };

    // console.log(mealTimeOptions);
    // here create an array that passed to api when user save diet
    //===========================================
    const handleAssignDietData = (selectedOption, meal_time_id, index) => {
        // console.log(selectedOption);
        // console.log(meal_time_id);
        // console.log(index)

        // set the no of dates to send diet  
        if (meal_time_id == 'noOfDietDays') {
            apiData.date = selectedOption
        }

        else if (index === 0 && selectedOption === NONE_RECIPE) {
            // no recipe for this meal time: empty its recipes, clear its other dropdowns and totals
            let noneData = apiData.assign_diet.find((record) => record.meal_time_id == meal_time_id)
            if (noneData) {
                noneData.assign_diet_recipe.forEach((_, i) => {
                    delete macrosMicrosTotal[recipeTotalsKey(meal_time_id, i)]
                    form.setFieldsValue({ ["recipe_dropdown" + meal_time_id + i]: i === 0 ? NONE_RECIPE : '' })
                })
                noneData.assign_diet_recipe = []
            } else {
                apiData.assign_diet.push({ 'meal_time_id': meal_time_id, 'assign_diet_recipe': [] })
            }
            setNoneMealTimes((ids) => ids.includes(meal_time_id) ? ids : [...ids, meal_time_id])
            setApiData(apiData)
        }

        else {
            // picking a recipe (or clearing) in the first dropdown undoes None
            if (index === 0) {
                setNoneMealTimes((ids) => ids.filter((mealTimeId) => mealTimeId != meal_time_id))
            }
            // check if meatime record is available in assign_diet array if false then push object 
            let updatedData = apiData.assign_diet.find((record) => record.meal_time_id == meal_time_id)
            // console.log('updatedData', updatedData);
            // console.log('meal_time_id', meal_time_id);

            if (!updatedData) {
                apiData.assign_diet.push({
                    'meal_time_id': meal_time_id,
                    'assign_diet_recipe': [selectedOption]
                })
            } else {
                // if (!selectedOption) {
                //     updatedData.assign_diet_recipe.splice(index, 1)
                // }
                // else {
                //     updatedData.assign_diet_recipe[index] = selectedOption
                // }
                // console.log(updatedData);
                // if mealtime object is available then check that is recipe id is available in diet array if FALSE then  
                let checkIfRecipeIdAvailable = updatedData.assign_diet_recipe.includes(selectedOption)
                // updatedData.assign_diet_recipe.push(selectedOption)
                updatedData.assign_diet_recipe[index] = selectedOption || ''
                // updatedData.assign_diet_recipe[index] = selectedOption

                if (!selectedOption) {
                    delete macrosMicrosTotal[recipeTotalsKey(meal_time_id, index)]
                }
                // console.log(updatedData);
            }
            setApiData(apiData)

        }

        // console.log(apiData);
        // console.log(macrosMicrosTotal);
        setApiData(apiData)
        setAssignDietApiData(apiData)
    }

    // display the no of dropdown from its dropdown count and 
    // fill the all recipe options in that dropdown
    //=================================================== 
    const HandleRecipeDropdown = (props) => {
        let meal_time_dropdown_count = handleAssignDietObject(props.mealTimeRecord.id)?.assign_diet_recipe.length >= props.mealTimeRecord.diet_dropdown_count ? handleAssignDietObject(props.mealTimeRecord.id)?.assign_diet_recipe.length : props.mealTimeRecord.diet_dropdown_count;
        const temp = []
        // {showErr && <Alert onClose={() => setShowErr(false)} message="Please Provide Medical Detail Tab Information First" type="warning" showIcon closable />}

        for (let i = 0; i < parseInt(meal_time_dropdown_count); i++) {
            temp.push(
                <>
                    <Col xs={22} sm={22} md={22} lg={22} xl={23} xxl={23} className="select_recipe_dropdown"
                        key={i}
                    >
                        {/* {console.log("recipe_dropdown" + props.mealTimeRecord.id + i)} */}
                        <Form.Item
                            name={"recipe_dropdown" + props.mealTimeRecord.id + i}
                            rules={[
                                {
                                    required: "recipe_dropdown" + props.mealTimeRecord.id + 0 ? true : false,
                                    message: "Please Select Recipe !"
                                },
                            ]}
                        // className="mb-0"
                        // initialValue=""
                        >
                            <Select
                                placeholder={<h6 className="mb-0 mt-4">Select Recipe</h6>}
                                defaultActiveFirstOption={true}
                                className="w-100 align-self-center text-start select_recipe_dropdown_list"
                                onChange={(e) => {
                                    // HandleTotalMacrosMicros(props.mealTimeRecord.id, i, props.mealTimeIndex)
                                    handleAssignDietData(e, props.mealTimeRecord.id, i);
                                    setFlag(!flag)
                                }}
                                key={"recipe" + props.mealTimeRecord.id + i}
                                disabled={i > 0 && isNoneMealTime(props.mealTimeRecord.id)}
                                allowClear
                                clearIcon={<CloseCircleFilled style={{ fontSize: "1.3rem", color: "red" }} />}
                            >
                                <Option value="" disabled hidden className="mt-4">
                                    <h6> Select Recipe</h6>
                                </Option>
                                {i === 0 &&
                                    <Option value={NONE_RECIPE} key={props.mealTimeRecord.id + '-none'} className="border-bottom mb-0">
                                        <h6 className="mb-0">None / Not assigned</h6>
                                    </Option>
                                }
                                {allRecipesListOption && allRecipesListOption.length > 0 && allRecipesListOption.map((recipeRecord, recipeIndex) =>
                                    // display recipe according to mealtime like In breakfast display breakfast related recipe by comparing mealtime Id
                                    //============================================= 
                                    (recipeRecord.recipe_meal_time.find((record) => record.meal_time_id == props.mealTimeRecord.id)) &&
                                    <Option
                                        // if one recipe is already selected in breakfast then disable it in other breakfast dropdown
                                        // apply same for others
                                        // ================================
                                        // disabled={apiData?.assign_diet.length > 0 && apiData.assign_diet.find(a => a.meal_time_id == props.mealTimeRecord.id)
                                        //     ?.assign_diet_recipe.includes(recipeRecord.id) ? true : false}
                                        className={recipeIndex === (allRecipesListOption.length - 1) ? 'mb-0 border-0' : 'border-bottom mb-0'}
                                        value={recipeRecord.id}
                                        key={props.mealTimeRecord.id + recipeIndex}>
                                        <h6>{recipeRecord.name}</h6>
                                        <div className="d-flex flex-wrap optionGroup mb-0">
                                            {recipeRecord?.recipe_tag_list
                                                && recipeRecord?.recipe_tag_list.length > 0 &&
                                                recipeRecord?.recipe_tag_list.map((tagData, tagIndex) =>
                                                    (tagData.recipe_tag.tagType == "Nutrient Tags" ||
                                                        tagData.recipe_tag.tagType == "Cuisine Tags" ||
                                                        tagData.recipe_tag.tagType == "Type of Diet Tags") &&
                                                    <Tag style={{ background: "#4159a8 " }} className="rounded my-1 border-0 text-white ">{tagData.recipe_tag.name}
                                                    </Tag>
                                                )}
                                        </div>
                                    </Option>
                                )
                                }
                            </Select>
                        </Form.Item>

                        <Row>
                            <Col xl={3} xxl={2} className="align-self-center" style={{ marginTop: "0.5%" }}>
                                <div id={"see_recipe_macros_micros" + props.mealTimeRecord.id + i} className="recipe_macros_section d-flex align-self-center">

                                    <Button
                                        className="border-primary rounded me-2 "
                                        disabled={form.getFieldValue("recipe_dropdown" + props.mealTimeRecord.id + i) ? false : true}
                                        onClick={() => {
                                            setViewRecipeData(allRecipesListOption.find(allrecipeRecords => allrecipeRecords.id == form.getFieldValue("recipe_dropdown" + props.mealTimeRecord.id + i)));
                                            setIsModalVisible(true)
                                        }}
                                    >
                                        See Recipe
                                    </Button>
                                </div>
                            </Col>
                            <Col xs={24} sm={24} md={16} lg={16} xl={16} xxl={15} className="align-self-center">
                                {/* {console.log("macrosMicrosOption", macrosMicrosTotalhtml["recipe_macros_micros" + props.mealTimeRecord.id + i])} */}
                                {
                                    macrosMicrosTotalhtml[recipeTotalsKey(props.mealTimeRecord.id, i)] !== undefined &&
                                        apiData?.assign_diet.length > 0 &&
                                        handleAssignDietObject(props.mealTimeRecord.id) &&
                                        handleAssignDietObject(props.mealTimeRecord.id)['assign_diet_recipe'][i] !== '' ?
                                        <div
                                            className="recipe-macro-total bordered d-flex  justify-space-around"
                                            dangerouslySetInnerHTML={{ __html: macrosMicrosTotalhtml[recipeTotalsKey(props.mealTimeRecord.id, i)].toString().replaceAll(',', ' ') }} />
                                        :
                                        <div className="recipe-macro-total bordered d-flex flex-wrap justify-space-around">
                                            <p className="total-macros-head">Macros</p>
                                            {
                                                macrosMicrosOption.map((totalMacorsOfRecipe) => (
                                                    <DisplayMacrosValues totalMacorsOfRecipe={totalMacorsOfRecipe} />
                                                ))
                                            }
                                        </div>
                                }
                            </Col>

                            {/* </div> */}
                        </Row>
                        {/* </div> */}
                    </Col>
                    <Col xs={2} sm={2} md={2} lg={2} xl={1} xxl={1} className="align-self-center text-center">
                        {/* display remove button for those drop down that are added by add new recipe drop down buttton   */}
                        {/* {props.mealTimeRecord.id == 1 && console.log("mealTimeOptionsList", props.mealTimeRecord?.diet_dropdown_count, mealTimeOptionsList.find(element => element.id == props.mealTimeRecord.id)?.diet_dropdown_count)} */}

                        {parseInt(props.mealTimeRecord?.diet_dropdown_count) > (parseInt(mealTimeOptionsList.find(element => element.id == props.mealTimeRecord.id)?.diet_dropdown_count)) &&
                            i >= (parseInt(mealTimeOptionsList.find(element => element.id == props.mealTimeRecord.id)?.diet_dropdown_count)) &&
                            <Popconfirm placement="leftTop"
                                title="Sure to delete?"
                                okText="Delete"
                                onConfirm={() => handleRecipeDropdownRemove(props.mealTimeRecord, i)}>
                                <Button className="border-danger rounded " icon={<DeleteOutlined className="text-danger" />}></Button>
                            </Popconfirm>
                        }
                    </Col>
                </>
            )
        }
        setLoading(false)
        return temp
    }

    // when user click on Delete icon Delete one dropdown count and also remove from apidata 
    //============================  
    const handleRecipeDropdownRemove = (mealtimeRecord, dropdownIndex) => {
        // console.log("MM",mealtimeRecord);
        // console.log(mealtimeID, dropDownCount);
        const MealTimeRecord = mealTimeOptions.find(element => element.id == mealtimeRecord.id)
        MealTimeRecord.diet_dropdown_count = parseInt(MealTimeRecord.diet_dropdown_count) - 1
        setMacrosMicrosFlag(!MacrosMicrosFlag)

        // delete the element from api data 
        handleAssignDietObject(mealtimeRecord.id).assign_diet_recipe.splice(dropdownIndex, 1)
        // console.log("apiData", apiData);

        // clear the drop down value form the given mealtime id and dropdown index
        form.setFieldValue("recipe_dropdown" + mealtimeRecord.id + dropdownIndex, '')
        setApiData(apiData)
    }

    // get the selected date and if on this date if already assigned diet data is available then fill it else clear form
    //================================
    const handleSelectedDate = (selected_date) => {
        // resetData()
        getListOfAlreadyAssignedDietData(selected_date)
    }

    // component to display all macros micros and its values
    //===================================
    const DisplayTotalMacrosMicros = ({ data }) => {
        // console.log("data",data);
        return (
            <Col xs={24} sm={12} md={6} lg={6} xl={6} xxl={6} >
                <div className="macros_item">
                    {/* <img src={EnergyIcon} className="macrosIcon" /> */}
                    <p className="macros_item_title">{data?.name} -</p>
                    <p className="macros_item_value"> {roundTotal(data?.total)} {data.unit}</p>
                </div>
            </Col>)
    }

    // handle macros micros filter and active button for each section
    // ======================================== 
    const handleRadioStyle = (data, stateName) => {
        MacrosMicros[stateName] = data;
        setMacrosMicros(MacrosMicros);
        setMacrosMicrosFlag(!MacrosMicrosFlag)
    }

    // function to check the selected recipe length after remove blank element from array
    // and dropdown count of that section by compare this we enable and disable add more recipe button 
    //================================
    const handleSelectedAssignDietRecipeLength = (mealTimeId) => {
        let selectedRecipeLength = handleAssignDietObject(mealTimeId)?.assign_diet_recipe.filter((element) => {
            return element !== "" && element !== null && element !== undefined;
        }).length;
        return selectedRecipeLength
    }

    return (
        <div className="AssignDietForm">
            <Spin spinning={loading} className="spinner-code">
                <Row>
                    <Col span={24} className="diet-form-header">
                        <h5 className="mb-0">Select a day from the panel to fetch the diet of the day</h5>
                    </Col>
                </Row>

                <Form
                    name="AssignDietFormData"
                    className="AssignDietFormData"
                    form={form}
                    layout="horizontal"
                    onFinish={onFinish}
                >
                    <Row>
                        <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} >
                            {/* <Col xl={24}> */}
                            <Form.Item
                                name="date"
                                rules={[
                                    { required: true, message: "Please Select Date !" },
                                ]}
                                className="mb-0"
                            >
                                <Radio.Group
                                    onChange={(e) => { setSelectedDate(e.target.value); handleSelectedDate(e.target.value) }}
                                    // className="d-flex overflow-auto w-100"
                                    className="d-flex flex-wrap w-100"
                                >
                                    {dateList && dateList.length > 0 && dateList.map((element, index) =>
                                        <Radio.Button
                                            className="w-auto"
                                            value={element.fullDate}>{element.day}<h5>{element.date}</h5></Radio.Button>
                                    )}
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                        <Col span={24} className="TotalMacrosMicros">
                            <div className="macrosMicrosButton">
                                <Radio.Group className="mt-2" defaultValue="Macros"
                                    onChange={(e) => { setMainActiveMacrosMicros(e.target.value) }}>
                                    <Radio.Button value="Macros">Macros</Radio.Button>
                                    <Radio.Button value="Micros">Micros</Radio.Button>
                                </Radio.Group>
                            </div>
                            <Row className="mt-2">
                                {console.log("grandTotal===", grandTotal)}
                                {
                                    Object.keys(grandTotal).length > 0 ?
                                        Object.entries(grandTotal).map(([element, data]) =>
                                            data.type == mainActiveMacrosMicros &&
                                            <DisplayTotalMacrosMicros data={data} />
                                        )
                                        :
                                        macrosMicrosOption.map((element, macrosIndex) =>
                                            element.type == mainActiveMacrosMicros &&
                                            <DisplayTotalMacrosMicros data={element} />
                                        )

                                }
                            </Row>
                        </Col>
                        {/* loop on the total available mealtime  */}
                        {/* ======================================== */}
                        {
                            mealTimeOptions && mealTimeOptions.length > 0 && mealTimeOptions.map((mealTimeRecord, mealTimeIndex) =>
                                <Col span={24} className="dietFormSection" key={mealTimeRecord.id + '--' + mealTimeIndex}>
                                    <div className="diet_form_component">
                                        <Row>
                                            <Col span={24} className="Section_Head">
                                                <p className="mb-0">{mealTimeRecord?.name}</p>
                                            </Col>
                                            <Col span={24} className="TotalMacrosMicros">
                                                <div className="macrosMicrosButton" >
                                                    <Radio.Group
                                                        name={mealTimeRecord?.name + mealTimeIndex}
                                                        className="mt-2"
                                                        value={MacrosMicros[mealTimeRecord?.name + mealTimeIndex]}
                                                        onChange={(e) => {
                                                            let state = mealTimeRecord?.name + mealTimeIndex
                                                            handleRadioStyle(e.target.value, state)
                                                        }}>
                                                        <Radio.Button key="Macros"
                                                            className="radioBtn"
                                                            checked={MacrosMicros[mealTimeRecord?.name + mealTimeIndex] == "Macros" ? true : false}
                                                            value="Macros">
                                                            Macros
                                                        </Radio.Button>
                                                        <Radio.Button key="Micros"
                                                            className="radioBtn2"
                                                            checked={MacrosMicros[mealTimeRecord?.name + mealTimeIndex] == "Micros" ? true : false}
                                                            value="Micros">
                                                            Micros
                                                        </Radio.Button>
                                                    </Radio.Group>
                                                </div>
                                                <Row className="mt-2" >
                                                    {
                                                        mealTimeTotal && ["recipe_macros_micros" + mealTimeRecord.id] in mealTimeTotal ?
                                                            Object.entries(mealTimeTotal["recipe_macros_micros" + mealTimeRecord.id]).map(([element, data]) =>
                                                            (
                                                                [mealTimeRecord?.name + mealTimeIndex] in MacrosMicros && (data.type == MacrosMicros[mealTimeRecord?.name + mealTimeIndex]) &&
                                                                <DisplayTotalMacrosMicros data={data} />
                                                            ))
                                                            :
                                                            macrosMicrosOption.map((element, macrosIndex) =>
                                                                [mealTimeRecord?.name + mealTimeIndex] in MacrosMicros && element.type == (MacrosMicros[mealTimeRecord?.name + mealTimeIndex]) &&
                                                                <DisplayTotalMacrosMicros data={element} />
                                                            )
                                                    }
                                                </Row>
                                            </Col>

                                            <Col span={24} className="d-flex justify-content-start text-start">
                                                {/* get the length of each section selected dropdown array length if blank array means 
                                                none drop down selected so display error message */}
                                                {showErr && !isNoneMealTime(mealTimeRecord.id) && !handleSelectedAssignDietRecipeLength(mealTimeRecord.id) > 0 && <Alert className=" w-25 meal-time-error" message="Please Select Minimum One Recipe" type="warning" showIcon closable />}
                                                {/* {console.log("showErr=", handleSelectedAssignDietRecipeLength(mealTimeRecord.id) > 0)} */}
                                            </Col>

                                            {/* Loop on select dropdown    */}
                                            {/* code for the recipe dropdown */}
                                            {/* ======================================== */}
                                            <HandleRecipeDropdown
                                                key={mealTimeRecord.id + '-' + mealTimeIndex}
                                                mealTimeRecord={mealTimeRecord}
                                                mealTimeIndex={mealTimeIndex}
                                            />

                                            {/* maximum 5 dropdown in each diet section  */}
                                            {
                                                mealTimeRecord.diet_dropdown_count < 5 &&
                                                <Col span={24}>
                                                    {/* {mealTimeRecord.id == 1 && 
                                                        console.log("mealTimeRecord.diet_dropdown_count", mealTimeRecord.diet_dropdown_count)} */}
                                                    <Button
                                                        // disabled the button if any of default drop down is not selected 

                                                        disabled={
                                                            isNoneMealTime(mealTimeRecord.id) ||
                                                            handleSelectedAssignDietRecipeLength(mealTimeRecord.id) == (
                                                                handleSelectedAssignDietRecipeLength(mealTimeRecord.id) >= mealTimeRecord.diet_dropdown_count ?
                                                                    handleSelectedAssignDietRecipeLength(mealTimeRecord.id) :
                                                                    mealTimeRecord.diet_dropdown_count) ?
                                                                false : true
                                                        }

                                                        // disabled={
                                                        //     // handleSelectedAssignDietRecipeLength
                                                        //     handleAssignDietObject(mealTimeRecord.id)?.assign_diet_recipe.length == (
                                                        //         handleAssignDietObject(mealTimeRecord.id)?.assign_diet_recipe.length >= mealTimeRecord.diet_dropdown_count ?
                                                        //             handleAssignDietObject(mealTimeRecord.id).assign_diet_recipe.length :
                                                        //             mealTimeRecord.diet_dropdown_count) ?
                                                        //         false : true
                                                        // }

                                                        onClick={() => aa(mealTimeRecord.id)} className="add-recipe-btn mt-1 border-0" icon={<PlusOutlined />}>
                                                        Add More Recipe
                                                    </Button>
                                                </Col>
                                            }
                                        </Row>
                                    </div>
                                </Col>
                            )}
                        <Col xs={24} md={24} xl={24} xxl={24} className=" align-self-center text-center">
                            {/* if the selected date has already assigned diet data then display update button  */}
                            {datesOfalreadyAssignedDiet.includes(selectedDate) ?
                                <>
                                    <Button className="b-0 sendDietBtn rounded me-2" onClick={() => handleSubmit("update")}>
                                        Update
                                    </Button>
                                    <Button className="b-0 sendDietBtn rounded" onClick={() => handleSubmit("update", true)}>
                                        Update & Send
                                    </Button>
                                </>
                                :
                                // choose the days first, then Save or Save & Send
                                <Button className="b-0 sendDietBtn rounded" onClick={() => setIsDietDaysModalVisible(true)}>
                                    Save Diet
                                </Button>
                            }
                        </Col>
                    </Row>

                    {/* modal to select same diet for how may days before send diet to patient */}
                    {/* ========================== */}
                    <Modal
                        open={isDietDaysModalVisible}
                        footer={null}
                        width={400}
                        centered
                        className="viewRecipeModal"
                        onOk={handleOk} onCancel={() => setIsDietDaysModalVisible(false)}
                    >
                        <Row className="text-center" gutter={[16, { xs: 8, sm: 16, md: 24, lg: 20 }]}>
                            <Col xl={24}>
                                <h5 className="mb-0">Select Days</h5>
                            </Col>
                            <Col xl={24}>

                                <Form.Item
                                    name="no_of_diet_days"
                                    rules={[
                                        { required: true, message: "Please Select Date !" },
                                    ]}
                                    className="mb-0"
                                >

                                    <Select
                                        placeholder="Select Days"
                                        allowClear
                                        showSearch
                                        onChange={(e) => handleAssignDietData(e, 'noOfDietDays')}
                                        maxTagCount="responsive"
                                        mode="multiple"
                                        className="w-100 px-4"
                                    >
                                        {/* display only those dates in which assigned diet is not available  */}
                                        {dateList && dateList.length > 0 && dateList.map((element) =>
                                            datesOfalreadyAssignedDiet.includes(element.fullDate) !== true &&
                                            <Option
                                                key={element.fullDate}>{element.fullDate}
                                            </Option>
                                        )}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={24} xl={24} xxl={24} className=" align-self-center text-center">
                                <Button className="submit-button mb-2 me-2 b-0 rounded" onClick={() => handleSubmit("add")}>
                                    SAVE
                                </Button>
                                <Button htmlType="submit" className="submit-button mb-2 b-0 rounded" onClick={() => handleSubmit("add", true)}>
                                    SAVE & SEND
                                </Button>
                                <p className="text-muted mb-1" style={{ fontSize: 12 }}>Save & Send emails the patient the full plan as a PDF.</p>
                                <p className="text-danger">{noOfDietDaysErrMsg}</p>
                            </Col>
                        </Row>
                    </Modal>
                </Form>
            </Spin>

            {/* View Recipe Modal  */}
            {/* ========================== */}
            <Modal
                open={isModalVisible}
                footer={null}
                width={900}
                centered={false}
                className="viewRecipeModal"
                onOk={handleOk} onCancel={handleCancel}
            >
                <ViewRecipe viewRecipeData={viewRecipeData} />
            </Modal>
        </div >
    )
}